import veritoneApi from './veritoneApi';
import { get, isEqual } from 'lodash';
import {
  ATTRIBUTE_APPLICATION_ID
} from '../helpers/constant';

export const EVENT_TYPE = 'Attribution App';
export const ATTRIBUTE_CAMPAIGN_EVENT_NAMES = [
  'CampaignProcessing',
  'CampaignComplete',
  'CampaignFailed',
  'CampaignUpdate',
  'CampaignPending'
]
export const ATTRIBUTE_ADVERTISER_EVENT_NAMES = [
  'AdvertiserPending',
  'AdvertiserProcessing',
  'AdvertiserComplete',
  'AdvertiserFailed',
  'GBQAdvertiserAlert'
]
export const ATTRIBUTE_FILES_EVENT_NAMES = [
  'FileProcessing',
  'FilePending',
  'FileFailed',
  'FileCompleted'
]
export const ATTRIBUTE_EVENT_NAMES = [
  ...ATTRIBUTE_CAMPAIGN_EVENT_NAMES,
  ...ATTRIBUTE_ADVERTISER_EVENT_NAMES,
  ...ATTRIBUTE_FILES_EVENT_NAMES
]

const FETCH_MAILBOX_QUERY = `
  query getMailBox {
    notificationMailboxes {
      id
      name
      totalCount
      unreadCount
      eventFilter {
        applicationId
        eventNames
        eventType
        conditions
      }
    }
  }`;

function genCreateMailboxQuery(userName, userId, eventNames) {
  return (
    `
    mutation {
      notificationMailboxCreate(input:{
        name: "${userName}",
        notificationTemplate:"{{message}}",
        eventFilter: {
            eventNames: ${JSON.stringify(eventNames)}
            eventType: "${EVENT_TYPE}"
            applicationId: "${ATTRIBUTE_APPLICATION_ID}"
            delivery:{
              deliveryType: NotificationMailbox
            }
            conditions: {
            conditions: [
              {
              field: "userId", 
              value: "${userId}", 
              operator: "eq"
              }
            ]
          }
        },
      }) {
        id
        name
      }
    }`
  )
};

function genDeleteMailboxQuery (mailboxId) {
  return `
  mutation deleteMailBox {
    notificationMailboxDelete(id: "${mailboxId}") {
      id
    }
  }`
}

export function fetchUserMailboxes(urlApi) {
  return veritoneApi(urlApi.graphql)
    .post('', { query: FETCH_MAILBOX_QUERY })
    .then(response => {
      return get(response, 'data.data.notificationMailboxes', []);
    })
    .catch(error => ({ error }));
};

export function deleteMailboxes(urlApi, mailboxId) {
  const query = genDeleteMailboxQuery(mailboxId);
  return veritoneApi(urlApi.graphql)
    .post('', { query })
    .then(response => {
      return get(response, 'data');
    })
    .catch(error => ({ error }));
};

export function getAttributeMailboxesWithEventNames(notificationMailboxes = []) {
  const attributeMailboxes = notificationMailboxes.filter(mailbox => {
    const applicationId = get(mailbox, 'eventFilter.applicationId');
    const eventNames = get(mailbox, 'eventFilter.eventNames', []);
    const eventType = get(mailbox, 'eventFilter.eventType');
    return (
      applicationId === ATTRIBUTE_APPLICATION_ID
      && eventType === EVENT_TYPE
      && isEqual(eventNames.sort(), [...ATTRIBUTE_EVENT_NAMES].sort())
    )
  })
  return attributeMailboxes;
};

export function createUserMailBoxes(urlApi, userName, userId, eventNames) {
  const query = genCreateMailboxQuery(userName, userId, eventNames);
  return veritoneApi(urlApi.graphql)
    .post('', { query: query })
    .then(response => {
      return get(response, 'data');
    })
    .catch(error => ({ error }));
};
